export default "__VITE_ASSET__Fci9xWCf__"